import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";


// const CustomLegend = () => (
//   <div style={{ display: "flex", gap: 20 }}>
//     <LegendItem color="#1E3A5F" label="Revenue" />
//     <LegendItem color="#16A34A" label="Cost" />
//     <LegendItem color="#38BDF8" label="Profit" />
//   </div>
// );

const LegendItem = ({ color, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: color,
      }}
    />
    <span style={{ fontSize: 14 }}>{label}</span>
  </div>
);

export default function CostRevenueChart({data}) {
  return (
    <div
      // style={{
      //   background: "#fff",
      //   padding: 20,
      //   borderRadius: 16,
      //   boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      // }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
       
        {/* <CustomLegend /> */}
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="4 4" vertical={false} />
          
          <XAxis dataKey="label" />
          
          <YAxis
            tickFormatter={(val) => `${val / 1000}K`}
          />

          <Tooltip />

          {/* Revenue */}
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#1E3A5F"
            strokeWidth={3}
            strokeDasharray="6 6"
            dot={false}
          />

          {/* Cost */}
          <Line
            type="monotone"
            dataKey="cost"
            stroke="#16A34A"
            strokeWidth={3}
            strokeDasharray="6 6"
            dot={false}
          />

          {/* Profit */}
          <Line
            type="monotone"
            dataKey="profit"
            stroke="#38BDF8"
            strokeWidth={3}
            strokeDasharray="6 6"
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}